import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import ProjectIssuesComponent from '../../components/project-dashboard/issues/ProjectIssuesComponent';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { getCurrentUserAssociation } from '../../modules/project';

const ProjectIssuesPage = () => {
  const { projectId } = useParams();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getCurrentUserAssociation(projectId);
        setIsAdmin(['org-admin', 'org-manager', 'admin'].includes(response?.role));
      } catch (error) {
        console.error(error);
      }
    };
    if (projectId) fetchUserData();
  }, [projectId]);

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <ProjectIssuesComponent isAdmin={isAdmin} />
        </Grid>
      </Grid>
    </DashboardLayout >
  );
};

export default ProjectIssuesPage;
